import { Cell, colors, LayoutBand, Row, Separator, Skeleton, useContainerWidth, WhiteTheme } from '@fs/zion-ui'
import { Person } from '@fs/zion-person'
import { css } from '@emotion/core'
import React from 'react'
import useQualityIndicatorFlag from '../../../data-service/useQualityIndicatorFlag'
import PersonQualityScoreButtonSkeleton from '../../../common/PersonQualityScoreButtonSkeleton'
import BannerActionsSkeleton from './BannerActionsSkeleton'

const actionsAlignCss = css`
  margin-inline-start: var(--start-padding);
`

export default function SourceCentricBannerSkeleton(): JSX.Element {
  const atSize = useContainerWidth()
  const avatarSize = atSize({ default: 'md', lg: 'lg' })
  const isDesktop = atSize({ default: false, lg: true })
  const hideText = atSize({ default: true, md: false })
  const { data: qualityIndicatorFlag } = useQualityIndicatorFlag()
  const showQualityScore = !!qualityIndicatorFlag?.isOn

  return (
    <div style={{ overflow: 'hidden' }}>
      <LayoutBand maxWidth="lg" color={colors.gray80} marginY="sm" marginX="nano">
        <WhiteTheme>
          <Row alignY="top" gutters="xs">
            <Cell growX>
              <Row alignY="middle">
                <Skeleton.Avatar size={avatarSize} />
                <Person loading hideAvatar componentSize="xl" lifespanSize="long" />
              </Row>
            </Cell>
            {isDesktop && (
              <Cell noShrinkX>
                <Row alignY="top" gutters="xxs">
                  {showQualityScore && <PersonQualityScoreButtonSkeleton variant="split" />}
                  <Skeleton.Chip maxWidth={140} />
                  <Skeleton.Chip maxWidth={100} />
                </Row>
              </Cell>
            )}
          </Row>
          <Separator size="nano" />
          <div
            css={actionsAlignCss}
            style={{
              '--start-padding': atSize({
                default: 'calc(64px + var(--spacer-sm) - 8px)',
                lg: 'calc(88px + var(--spacer-sm) - 8px)',
              }),
            }}
          >
            <BannerActionsSkeleton hideText={hideText} />
          </div>
        </WhiteTheme>
      </LayoutBand>
    </div>
  )
}
